import { getChartDefinition } from '../domain/catalog';
import type { ChartInput, ChartResult } from '../domain/types';
import { isChunkLoadError, recoverStaleChunk } from '../runtime/chunkRecovery';
import { parseChartDate } from './helpers';
import { validateChartInput, validateChartResult } from './validateInput';

export async function runChart(input: ChartInput): Promise<ChartResult> {
  const definition = getChartDefinition(input.moduleId);
  if (!definition) throw new Error('未找到所选术数模块。');
  const date = parseChartDate(input.dateTime);
  validateChartInput(input, definition);
  try {
    const [{ configure }, adapter] = await Promise.all([
      import('mingyu-core/calendar'),
      definition.load()
    ]);
    // 底层占筮库默认固定东八区；页面却明确按设备本地时区接收墙上时间。
    // 在每次计算前同步当前日期的真实本地偏移，避免 UTC CI 或海外设备把同一输入错移 8 小时。
    configure({ timezoneOffset: -date.getTimezoneOffset() });
    const result = await adapter.run(input, date);
    return validateChartResult(result, definition);
  } catch (cause) {
    if (await recoverStaleChunk(cause, input.moduleId)) {
      throw new Error('网站正在更新，页面会自动刷新。刷新后请重新生成排盘。');
    }
    if (isChunkLoadError(cause)) {
      throw new Error(typeof navigator === 'undefined' || navigator.onLine
        ? '术数模块没有成功加载，请刷新页面后重试。'
        : '当前处于离线状态，且该术数模块尚未缓存。请联网打开一次后再使用。');
    }
    throw cause;
  }
}
